import { render, staticRenderFns } from "./AddKnowledge.vue?vue&type=template&id=3b53d96b&scoped=true"
import script from "./AddKnowledge.vue?vue&type=script&lang=js"
export * from "./AddKnowledge.vue?vue&type=script&lang=js"
import style0 from "./AddKnowledge.vue?vue&type=style&index=0&id=3b53d96b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b53d96b",
  null
  
)

export default component.exports